import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Sidebar from "../sidebar/SideBar";
import routes from "../../Routes";
import "./dashboard.css";

const MOBILE_WIDTH = 768;

// Shell shared by the user, operator, admin and sales spaces
function DashboardLayout({ layout, Navbar }) {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_WIDTH);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const spaceRoutes = routes.filter((route) => route.layout === layout);
  const homePath = `${layout}/home`;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= MOBILE_WIDTH);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // The mobile menu closes itself after each navigation
  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  const toggleSidebar = () => setIsSidebarOpen((open) => !open);

  return (
    <div className="dash-shell">
      {isMobile && isSidebarOpen && (
        <div
          className="dash-overlay"
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <Sidebar
        isOpen={isSidebarOpen || !isMobile}
        toggleSidebar={toggleSidebar}
        routes={spaceRoutes}
      />

      <div className="dash-main">
        <Navbar toggleSidebar={toggleSidebar} />

        <main className="dash-content">
          <Routes>
            <Route path="/" element={<Navigate to={homePath} />} />
            {spaceRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<route.component />}
              />
            ))}
            <Route path="*" element={<Navigate to={homePath} />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
